<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close" (click)="dismissModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <h3 class="mb-4">{{prompt}}</h3>
</div>